import { render, staticRenderFns } from "./TgPagination.vue?vue&type=template&id=23499b48"
import script from "./TgPagination.vue?vue&type=script&lang=js"
export * from "./TgPagination.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports